import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class PaymentReportService {

  readonly rootUrl = AppSettings.webApiURL; 
  constructor(public httpClient: HttpClient) { }

  public GetMonths() {
    return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetMonths`);
  }

  public GetReport(customerId, month) {
    //return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetReport?customerId=${customerId}&month=${month}`);
    //return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetPaymentReport3Regular?customerId=${customerId}&month=${month}`);
    return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetPaymentReport3RegularIncludesGapsForPast?customerId=${customerId}&month=${month}`);
  }

  public GetReportAggregated(customerId, month) {
    //return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetReportAggregated?customerId=${customerId}&month=${month}`);
    return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetPaymentReport3RegularIncludesGapsForPastAggregated?customerId=${customerId}&month=${month}`);
  }

  getCustomerDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetListCustomerDDL`);
  }

  // downloadExcelSpecialData(customerId, month, isGapDataView) {
  //   return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/downloadExcelSpecialData?customerId=${customerId}&month=${month}&isGapDataView=${isGapDataView}`, { responseType: 'blob' });
  // }
  
  downloadExcelSpecialData(data, month) {
    const headers = new HttpHeaders().set('content-type', 'application/json');//.set('responseType','blob');
    return this.httpClient.post(`${this.rootUrl}/api/PaymentReport/downloadExcelSpecialData?month=${month}`, data, { headers, responseType: 'blob' });
  }

  // public FreezePaymentReport(SessionId, recordsCount, month) {
  //   return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/FreezePaymentReport?SessionId=${SessionId}&recordsCount=${recordsCount}&month=${month}`);
  // }  

  public FreezePaymentReport(data, month) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/PaymentReport/FreezePaymentReport?month=${month}`, data, { headers });
  }  

  public GetFrozenPaymentReport(month) {
    return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetFrozenPaymentReport?month=${month}`);
  }

  public GetGapPaymentReport(month) {
    return this.httpClient.get(`${this.rootUrl}/api/PaymentReport/GetGapPaymentReport?month=${month}`);
  }


}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/payment-report.service.ts